// extracted by mini-css-extract-plugin
module.exports = {"selectorPeriodeBoto":"VisualitzacioParametresCerca_selectorPeriodeBoto__2e9Ic"};